
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";

interface WaitlistConsentProps {
  formData: {
    gdprConsent: boolean;
    noSpamPromise: boolean;
    communicationPreferences?: {
      email: boolean;
      sms: boolean;
    };
  };
  setFormData: (data: any) => void;
  isPro: boolean;
}

export const WaitlistConsent = ({
  formData,
  setFormData,
  isPro,
}: WaitlistConsentProps) => {
  return (
    <div className="space-y-4">
      <div className="flex items-center space-x-2">
        <Checkbox
          id="gdpr"
          checked={formData.gdprConsent}
          onCheckedChange={(checked) =>
            setFormData({
              ...formData,
              gdprConsent: checked as boolean,
            })
          }
          required
        />
        <Label
          htmlFor="gdpr"
          className="text-sm text-gray-600 leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
        >
          {isPro
            ? "J'accepte de recevoir des informations sur le lancement de NLocale Pro"
            : "Je ne veux pas rester à l'écart des meilleures expériences locales. J'accepte de recevoir des informations de NLocale"}
        </Label>
      </div>

      <div className="flex items-center space-x-2">
        <Checkbox
          id="noSpam"
          checked={formData.noSpamPromise}
          onCheckedChange={(checked) =>
            setFormData({
              ...formData,
              noSpamPromise: checked as boolean,
            })
          }
          required
        />
        <Label
          htmlFor="noSpam"
          className="text-sm text-gray-600 leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
        >
          Je comprends que je peux me désinscrire à tout moment
        </Label>
      </div>
    </div>
  );
};
